

import rest from "@/plugins/rest";
import bus from "@/plugins/bus";
import connectionStorage from '@/plugins/connectionStorage'

const user = {

    state: () => {
        return {

            //профиль пользователя
            user: false,

            //права доступа
            access: false,

            //дата последней активности
            lastActivityDate: Date.now()
            
        }
    },
    getters: {
        getUserProfile(state) {
            return state.user;
        },

        getAccess(state) {
            return state.access;
        },

        getServices(state,getters,rootState) {

            let services = rootState.clientSettings ? rootState.clientSettings.services : [];

            return services;
        },

        getUserDataBatch() {

            let requests = {
                user: {
                    ENTITY: "user",
                    METHOD: "profile.get",
                },
                access: {
                    ENTITY: "user",
                    METHOD: "access"
                }
            };

            return requests;
        },

        /**
         * Дата последней активности пользователя
         */
        getLastActivityDate(state) {
            return state.lastActivityDate
        }
    },

    mutations: {

        /**
         * Устанавливает данные профиля пользователя
         */
        setUserProfile: (state, value) => {
            state.user = value;
        },

        /**
         * Устанавливает права доступа пользователя
         */
        setAccess: (state, value) => {
            state.access = value;
        },

        /**
         * Устанавливает дату последней активности пользователя
         */
        setLastActivityDate: (state, value) => {
            state.lastActivityDate = value
        }

    },

    actions: {

        /**
         * Загружает данные пользователя
         */
        loadUserData(context) {

            //запрашиваем данные
            rest
                .batch(context.getters.getUserDataBatch)
                .then((results) => {
                    for (var key in results) {
                        let data = results[key];
                        if (data.success) {
                            //профиль пользователя
                            if (key == "user") {
                                context.commit('setUserProfile', data.fields);
                                context.dispatch('saveUserProfileData');
                            }
                            //права пользователя
                            else if (key =="access") {
                                context.commit('setAccess', data.access);
                            }
                            
                        } else {
                            //показываем сообщение об ошибке
                            bus.emit('OKRAINA_MESSAGE_E_SHOW', { message: data.errorText });
                            return;
                        }
                    }
                });
         
        },

        /**
         * Сохраняет в данных подключения некоторые поля профиля
         */
        saveUserProfileData(context) {

            let arConnection = connectionStorage.getConnection()
            let userProfice = context.getters.getUserProfile
            arConnection.profile = {
                name: userProfice.name,
                last_name: userProfice.last_name
            };
            connectionStorage.updateConnection(arConnection)
        },

    }

}

export default user;